<template>
  <div class="info-container">
    <div class="info-box">
      <h2>个人信息</h2>
      
      <el-form :model="userInfo" :rules="rules" ref="infoForm" label-width="100px">
        <!-- 头像 -->
        <el-form-item label="头像">
          <div class="avatar-upload">
            <ImageUpload v-model="userInfo.avatar" :limit="1"></ImageUpload>
          </div>
        </el-form-item>

        <!-- 昵称 -->
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="userInfo.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>

        <!-- 手机号 -->
        <!-- <el-form-item label="手机号" prop="mobile">
          <el-input v-model="userInfo.mobile" placeholder="请输入手机号">
            <template slot="append">
              <el-button @click="sendCode" :disabled="codeTimer > 0">
                {{ codeTimer > 0 ? `${codeTimer}s` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item> -->

        <!-- 验证码 -->
        <!-- <el-form-item label="验证码" prop="code">
          <el-input v-model="userInfo.code" placeholder="请输入验证码"></el-input>
        </el-form-item> -->

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存修改</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateUser, sendSms } from '@/api/signUp';
export default {
  name: 'Info',
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      userInfo: {
        avatar: '',
        nickname: '',
        mobile: '',
        code: ''
      },
      rules: {
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 2, max: 20, message: '昵称长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ]
      },
      loading: false,
      codeTimer: 0,
      timer: null,
      phone: ''
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 加载用户信息
    loadUserInfo() {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        this.userInfo = {
          avatar: userInfo.avatar || '',
          nickname: userInfo.nickname || '',
          mobile: userInfo.mobile || '',
          code: ''
        };
        this.phone = userInfo.mobile;
      }
    },

    // 头像上传前验证
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 发送验证码
    sendCode() {
      if (!this.userInfo.mobile) {
        this.$message.warning('请先输入手机号');
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.userInfo.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }

      // 调用发送验证码API
      sendSms({
        phone: this.userInfo.mobile,
        event:'profile',
      }).then(response => {
        if (response.data.code == 1) {
          this.$message.success('验证码发送成功');
          this.startCountdown();
        } else {
          this.$message.error(response.data.msg || '验证码发送失败');
        }
      }).catch(error => {
        console.error('验证码发送失败:', error);
        this.$message.error('验证码发送失败');
      });
    },

    // 倒计时
    startCountdown() {
      this.codeTimer = 60;
      this.timer = setInterval(() => {
        this.codeTimer--;
        if (this.codeTimer <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 提交表单
    submitForm() {
        if(this.phone!=this.userInfo.mobile){
            this.$message.warning('手机号已修改，请重新发送验证码');
            return;
        }
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          updateUser({
            avatar: this.userInfo.avatar,
            nickname: this.userInfo.nickname,
            mobile: this.userInfo.mobile,
            captcha: this.userInfo.code
          }).then(res=>{
            if(res.data.code==1){
                this.$message.success('修改成功');
                this.loading = false;
            }else{
                this.$message.error(res.data.msg);
                this.loading = false;
            }
          })
        }
      });
    },

    // 重置表单
    resetForm() {
      this.$refs.infoForm.resetFields();
      this.loadUserInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
.info-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;

  .info-box {
    max-width: 600px;
    margin: 0 auto;
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    h2 {
      text-align: center;
      margin-bottom: 30px;
      color: #333;
    }

    .avatar-upload {
      .avatar-uploader {
        .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: border-color 0.3s;

          &:hover {
            border-color: #409EFF;
          }
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
        }

        .avatar {
          width: 100px;
          height: 100px;
          display: block;
          border-radius: 6px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>